import { define } from "../preactement/define";
import { Badge } from "../../Badge";
const attributes = ['class-name', 'size', 'variation'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-badge', () => Badge, {
  attributes
});